import { useEffect } from "react";
import Testimonials from "../components/Testimonials";
import CtaBanner from "../components/CtaBanner";

const RecenziiPage = () => {
  useEffect(() => {
    document.title = "Recenzii | MEDAS Stomatologie Timișoara";
  }, []);

  return (
    <div className="pt-[76px] md:pt-[112px]">
      <Testimonials />
      <CtaBanner />
    </div>
  );
};

export default RecenziiPage;
